import { render, staticRenderFns } from "./FeesAndChargesTable.vue?vue&type=template&id=69a05010"
import script from "./FeesAndChargesTable.vue?vue&type=script&lang=js"
export * from "./FeesAndChargesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports